import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark as close, faFileArrowDown as save } from '@fortawesome/free-solid-svg-icons';
import { favoritesShow } from '../../store/favoritesSlice';
import axios from 'axios';
import { API_URL } from '../../config';
import FavoritesSwitch from './FavoritesSwitch';
import FavoritesActivities from './FavoritesActivities';
import FavoritesExhibitors from './FavoritesExhibitors';
import './Favorites.css';

const Favorites = () => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const event = useSelector(state => state.event);
    const favorites = useSelector(state => state.favorites.list);
    const isVisible = useSelector(state => state.favorites.isVisible);
    const dispatch = useDispatch();
    const nodeRef = useRef(null);
    const [ activities, setActivities ] = useState([]);
    const [ exhibitors, setExhibitors ] = useState([]);
    const [ mode, setMode ] = useState('exhibitors');

    useEffect(() => {
        if(event) {
            let list = favorites[event._id];
            let activities = list?.activities ? [...list.activities] : [];
            let exhibitors = list?.exhibitors ? [...list.exhibitors] : [];
            activities.sort((a, b) => a.date.localeCompare(b.date));
            exhibitors.sort((a, b) => a.name[lang].localeCompare(b.name[lang]));
            setActivities(activities);
            setExhibitors(exhibitors);
        } else {
            setActivities([]);
            setExhibitors([]);
        }
    }, [ event, favorites, lang ]);

    // Экспорт избранного в PDF
    const onExport = async () => {
        // Используем axios напрямую т.к. надо установить responseType
        // для корректной обработки бинарного ответа сервера
        const result = await axios.post(`${API_URL}/favorites`, {
            event: event._id,
            activities: activities.map(item => item._id).join(','),
            exhibitors: exhibitors.map(item => item._id).join(','),
            lang,
        }, {
            responseType: 'arraybuffer' // возможно лучше использовать blob?
        });
        if(result.error) return;
        const blob = new Blob([result.data], { type: 'application/pdf'});
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'favorites.pdf';
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(link.href);
        link.parentNode.removeChild(link);
    };

	return (
        <CSSTransition
            nodeRef={nodeRef}
            in={isVisible}
            timeout={300}
            classNames='Favorites'
            unmountOnExit
            onEnter={() => dispatch(favoritesShow(true))}
            onExited={() => dispatch(favoritesShow(false))}
        >
            <div className='Favorites' ref={nodeRef}>
                <div
                    className='background'
                    onClick={() => dispatch(favoritesShow(!isVisible))}
                />
                <div className='content'>
                    <div className='title'>
                        <h1 className='title-text'>{t('favorites.title')}</h1>
                        <h1 className='title-icon'>
                            <FontAwesomeIcon
                                icon={close}
                                onClick={() => dispatch(favoritesShow(false))}
                            />
                        </h1>
                    </div>

                    {event &&
                    <div className='Title'>
                        <div className='Name'>{event.name[lang]}</div>
                        {(activities.length > 0 || exhibitors.length > 0) &&
                        <div className='Export' onClick={() => onExport()}>
                            {t('favorites.export')}&nbsp;&nbsp;
                            <FontAwesomeIcon icon={save}/>
                        </div>}
                    </div>}

                    {/* Переключатель выводим только в том случае, если у мероприятия есть активности */}
                    {event?.activities_count > 0 && <FavoritesSwitch mode={mode} setMode={setMode}/>}
                    
                    {mode === 'activities' && <FavoritesActivities activities={activities}/>}
                    {mode === 'exhibitors' && <FavoritesExhibitors exhibitors={exhibitors}/>}
                </div>
            </div>
        </CSSTransition>
	);
};

export default Favorites;
